import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

/**
 * Reusable FAQ block. `items` is an array of { q, a } (a can be string or JSX).
 */
export default function FAQBlock({
  eyebrow = "FAQs",
  title = "Frequently asked questions",
  intro,
  items = [],
  bg = "white",
  id,
}) {
  const wrap = bg === "slate" ? "bg-slate-50 border-y border-slate-200" : "bg-white";
  return (
    <section id={id} className={`fss-section ${wrap}`} data-testid="faq-block">
      <div className="fss-container">
        <div className="max-w-3xl mb-10">
          <div className="fss-overline">{eyebrow}</div>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-semibold text-slate-900 leading-tight">
            {title}
          </h2>
          {intro && (
            <p className="mt-3 text-slate-600 leading-relaxed">{intro}</p>
          )}
        </div>

        <div className="max-w-3xl">
          <Accordion type="single" collapsible className="w-full">
            {items.map((it, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="border-slate-200"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="text-left font-display text-base md:text-lg font-semibold text-slate-900 hover:no-underline">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed text-sm md:text-base">
                  {it.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
